var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { mediaQueries } from '../../../common/deviceSize';
import { D } from './D';
export var D1 = styled(D)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t/* Display/D1 */\n\tfont-size: 5rem;\n\tline-height: 130%;\n\t", " {\n\t\tfont-size: 6.69rem;\n\t}\n"], ["\n\t/* Display/D1 */\n\tfont-size: 5rem;\n\tline-height: 130%;\n\t", " {\n\t\tfont-size: 6.69rem;\n\t}\n"])), mediaQueries.tablet);
var templateObject_1;
